"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var Cell_1 = __importDefault(require("atomicComponents/molecules/Table/Cell"));
var GenericTableRow_1 = __importDefault(require("atomicComponents/molecules/Table/TableRows/GenericTableRow"));
var Money_1 = __importDefault(require("components/Money"));
var SummaryRow = function (_a) {
    var subTotal = _a.subTotal, frequency = _a.frequency, name = _a.name;
    return ((0, jsx_runtime_1.jsxs)(GenericTableRow_1.default, { children: [(0, jsx_runtime_1.jsx)(Cell_1.default, { flex: "none", hasGutter: true, width: 8 }), (0, jsx_runtime_1.jsx)(Cell_1.default, __assign({ flex: "none", isSticky: true, hasGutter: true, width: 240, left: 0, fontWeight: "bold" }, { children: name })), (0, jsx_runtime_1.jsx)(Cell_1.default, { flex: "none", hasGutter: true, width: 545 }), (0, jsx_runtime_1.jsx)(Cell_1.default, __assign({ flex: "none", isSticky: true, hasGutter: true, width: 220, left: 0, fontWeight: "bold", textAlign: "right" }, { children: !!subTotal && (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Money_1.default, { amount: subTotal, isRounded: true }), " ", frequency] }) }))] }));
};
exports.default = react_1.default.memo(SummaryRow);
